import React from "react";
import sentImage from "assets/HomeAssets/Images/sent.png";
import { t } from "i18next";

const ContactAdminModal = (props) => {
  return (
    <div className="signin_modal job_modal sucess_modal">
      <div
        className="modal fade show"
        id="contact_admin_modal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={() => {
                //   props.displayEmailModal(false);
                // }}
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>

            <div className="modal-body">
              <div className="login_body">
                <div className="success_mdlpic">
                  <img src={sentImage} alt="" />
                </div>
                <div className="congrats_text">
                  <h3>{t("Thanks! Please wait for admin approval")}</h3>
                  <h5>
                    {t(
                      "Your login privilege is pending Admin approval. Please contact Admin to activate your account"
                    )}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactAdminModal;
